import { http } from '@/network/http';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

export function useVideos(status?: string, page = 1, limit = 20) {
  return useQuery({
    queryKey: ['videos', status, page, limit],
    queryFn: () =>
      http.get('/videos', { params: { status, page, limit } }).then((r) => r.data),
  });
}

export function useVideo(id: string) {
  return useQuery({
    queryKey: ['videos', id],
    queryFn: () => http.get(`/videos/${id}`).then((r) => r.data),
    enabled: !!id,
  });
}

export function useCreateVideo() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: Record<string, unknown>) => http.post('/videos', data).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['videos'] }),
  });
}

export function useUpdateVideo() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...data }: { id: string } & Record<string, unknown>) =>
      http.put(`/videos/${id}`, data).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['videos'] }),
  });
}

export function useDeleteVideo() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => http.delete(`/videos/${id}`).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['videos'] }),
  });
}

export function usePublishVideo() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => http.post(`/videos/${id}/publish`).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['videos'] }),
  });
}

export function usePresignUpload() {
  return useMutation({
    mutationFn: (data: { filename: string; mimeType: string; purpose: string }) =>
      http.post('/uploads/presign', data).then((r) => r.data),
  });
}
